const PaginationToNext = ({ paginationData, moveNext }) => {
  if (paginationData.has_next_page) {
    return (
      <button
        className="pagination__step pagination__step--next"
        onClick={moveNext}
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 2.66668L4.66667 8L10 13.3333"
            stroke="#ACACBB"
            strokeWidth="1.6"
          />
        </svg>
      </button>
    );
  }
};

export default PaginationToNext;
